import { useLiveQuery } from 'dexie-react-hooks'
import { db } from '../lib/db'
import { flushOutbox } from '../lib/sync'

/**
 * Badge en el header que muestra cuántos eventos están pending de sync.
 * Reactivo: se actualiza automáticamente conforme cambia el outbox (Dexie liveQuery).
 *
 * Click → fuerza flushOutbox manualmente (útil cuando red volvió pero el sync
 * periódico aún no corrió).
 */
export default function OutboxIndicator() {
  const pending = useLiveQuery(
    () => db.outbox.where('sync_status').equals('PENDING').count(),
    [],
    0,
  )
  const failed = useLiveQuery(
    () => db.outbox.where('sync_status').equals('FAILED').count(),
    [],
    0,
  )

  if (!pending && !failed) return null

  return (
    <button
      onClick={() => flushOutbox()}
      title="Click para sincronizar ahora"
      className={`text-xs font-bold px-2 py-1 rounded ml-2 ${
        failed
          ? 'bg-red-200 text-red-900'
          : 'bg-amber-300 text-amber-900'
      }`}
    >
      {failed
        ? `${failed} error${failed !== 1 ? 'es' : ''}`
        : `${pending} pendiente${pending !== 1 ? 's' : ''}`}
    </button>
  )
}
